import React, { Component } from "react";
import {
  MetaRegion,
  MetaRegionMensual,
  ProcesoResultado
} from "../../../../types/AnualidadMetaCarga";
import { formatMoney } from "../../../helpers/formatters";

interface Props {
  metasRegiones: MetaRegion[];
}

export default class ConfiguracionMetasRegionalesTable extends Component<
  Props
> {
  getRowStyle = (resultado: ProcesoResultado) => {
    switch (resultado) {
      case ProcesoResultado.ERROR:
        return { backgroundColor: "#f8d7da" };
      case ProcesoResultado.WARNING:
        return { backgroundColor: "#fffbdbff" };
      default:
        return {};
    }
  };

  renderMonthlyColumns = (metasMensuales: MetaRegionMensual[]) => {
    if (!metasMensuales || metasMensuales.length === 0) return null;

    return metasMensuales.map((meta, idx) => (
      <td key={idx}>
        {meta && meta.metaPresupuestada !== null
          ? formatMoney(meta.metaPresupuestada, 2)
          : formatMoney(0, 2)}
      </td>
    ));
  };

  calcularTotalMensual = (metasMensuales: MetaRegionMensual[]) => {
    if (!metasMensuales || metasMensuales.length === 0) {
      return formatMoney(0, 2);
    }
    return formatMoney(
      metasMensuales.reduce(
        (acc, meta) => acc + (meta.metaPresupuestada || 0),
        0
      ),
      2
    );
  };

  render() {
    const { metasRegiones } = this.props;

    if (!metasRegiones || metasRegiones.length === 0) {
      return null;
    }

    const mesesHeaders = metasRegiones[0].metasMensuales
      ? metasRegiones[0].metasMensuales.map(m => m.mes)
      : [];

    return (
      <>
        <div className="mb-4">
          <div className="row mt-4">
            <div className="col-12">
              <h5 className="mb-3">
                <strong>Metas Presupuestadas</strong>
              </h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th>Región</th>
                      <th>Total Presupuestado</th>
                      {mesesHeaders.map(mes => (
                        <th key={mes}>{mes}</th>
                      ))}
                      <th>Mensaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {metasRegiones.map((region, i) => (
                      <tr key={i} style={this.getRowStyle(region.resultado)}>
                        <td>
                          <strong>Región {region.numeroRegion}</strong>
                        </td>
                        <td>
                          <strong>
                            {this.calcularTotalMensual(region.metasMensuales)}
                          </strong>
                        </td>
                        {this.renderMonthlyColumns(region.metasMensuales)}
                        <td>{region.mensaje || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
